export default __webpack_public_path__ + "static/media/information--camp--g1.84c6b6d9.png";